module.exports = __webpack_public_path__ + "static/img/gift-7.3f9b504.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/winter-camp/assets/gift-7.png
// module id = 367
// module chunks = 140